import { createSlice } from '@reduxjs/toolkit';

const showAddProductSlice = createSlice({
    name: 'addProductButton',
    initialState: {
        toShow: false,
    },
    reducers: {
        showAddButton: (state, action) => {
            state.toShow = action.payload;
        },
    },
});

export const { showAddButton } = showAddProductSlice.actions;
export default showAddProductSlice.reducer;
